import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { getAllGoroupUserData } from "Stores/actions";
import { Grid } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import ExpandUserGroup from "./ExpandUserGroup/ExpandUserGroup";
import { useTranslation } from "react-i18next";

export default function UsersGroups() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [accordionExpanded, setAccordionExpanded] = useState(-1);
  const { allGroupUserData } = useSelector((state) => ({
    allGroupUserData: state.user.allGroupUserData,
  }));

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        await dispatch(getAllGoroupUserData(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="customer-groups-section">
      <span className="normalTitle">{t("userGroups")}</span>
      <Grid item xs={12} className="px-0 groups-list">
        {loading ? (
          <Grid item xs={12}>
            <Skeleton
              variant="text"
              animation="wave"
              width={"100%"}
              className="mb-4"
            />
            <Skeleton
              variant="text"
              animation="wave"
              width={"100%"}
              className="mb-4"
            />
            <Skeleton
              variant="text"
              animation="wave"
              width={"100%"}
              className="mb-4"
            />
            <Skeleton
              variant="text"
              animation="wave"
              width={"100%"}
              className="mb-4"
            />
            <Skeleton
              variant="text"
              animation="wave"
              width={"100%"}
              className="mb-4"
            />
            <Skeleton variant="text" animation="wave" width={"100%"} />
          </Grid>
        ) : (
          allGroupUserData.map((group, i) => {
            return (
              <div key={i} className="mb-2 paper-no-padding">
                <ExpandUserGroup
                  row={allGroupUserData[i]}
                  expanded={accordionExpanded}
                  onChangeExpanded={(value) => setAccordionExpanded(value)}
                />
              </div>
            );
          })
        )}
      </Grid>
    </div>
  );
}
